module.exports = __webpack_public_path__ + "img/50D.77554b52.png";